export type GstCategoryAppearanceChoice = 'tra' | 'ar' | 'ap';
